// Typelizer digest 3835ad568a42a3e03493250afde61e41
//
// DO NOT MODIFY: This file was automatically generated by Typelizer.
import type { RouteDefinition, RouteOptions } from '../../runtime'
import { buildUrl } from '../../runtime'

export default {
  /** POST /c/:company_id/products/:product_id/prices */
  create: (
    params: { productId: string | number } | string | number,
    options?: RouteOptions,
  ): RouteDefinition<'post'> => ({
    url: buildUrl('/c/:company_id/products/:product_id/prices', params, options),
    method: 'post',
  }),

  /** DELETE /c/:company_id/products/:product_id/prices/:id */
  destroy: (
    params: { productId: string | number; id: string | number },
    options?: RouteOptions,
  ): RouteDefinition<'delete'> => ({
    url: buildUrl('/c/:company_id/products/:product_id/prices/:id', params, options),
    method: 'delete',
  }),
}
